import { QueryClient } from "@tanstack/react-query";
import { isFetchClientError } from "@shared/apis/fetch-clients/fetch-client-error";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error) =>
        failureCount < 3 && !isFetchClientError(error),
    },
  },
});
